import { isAndroid, isMobile, isTablet } from 'react-device-detect';
import { isNotStandaloneMobilePWA, isStandalonePWA } from './mobileSupported';

export const createStyledBreakpointsTheme = () => {
  const breakpoints = {
    sm: 1280,
    md: 1366,
    lg: 1536,
    xl: 1600,
    xxl: 1920,
  };

  const up = key => (isMobile || isTablet ? '' : `@media (min-width: ${breakpoints[key]}px)`);
  const down = key => (isMobile || isTablet ? '' : `@media (max-width: ${breakpoints[key]}px)`);
  const between = (min, max) =>
    isMobile || isTablet ? '' : `@media (min-width: ${breakpoints[min]}px) and (max-width: ${breakpoints[max]}px)`;
  const only = key => {
    const keys = Object.keys(breakpoints);
    const index = keys.indexOf(key);

    const minValue = breakpoints[key];

    // If this is the last breakpoint, use the "up" query.
    if (index === keys.length - 1) return `@media (min-width: ${minValue}px)`;

    // Use the next breakpoint as the upper bound minus a small offset.
    const nextKey = keys[index + 1];
    const maxValue = breakpoints[nextKey] - 0.02; // subtract a small offset to avoid overlap
    return isMobile || isTablet ? '' : `@media (min-width: ${minValue}px) and (max-width: ${maxValue}px)`;
  };

  return {
    up,
    down,
    between,
    only,
  };
};

export const createStyledScreensTheme = () => {
  const screens = {
    'mobile-browser': isNotStandaloneMobilePWA && !isTablet,
    'mobile-standalone': isStandalonePWA && !isTablet,
    'tablet-browser': isNotStandaloneMobilePWA && isTablet,
    'tablet-standalone': isStandalonePWA && isTablet,
  };

  const device = key => screens[key];
  const devices = keys => keys.some(key => screens[key]);

  return {
    device,
    devices,
  };
};

export const createStyledPlatformTheme = () => {
  const platforms = {
    android: isAndroid,
    ios: !isAndroid,
  };

  const platform = key => platforms[key];

  return platform;
};

